<!-- HK Wrapper -->
<div class="hk-wrapper hk-vertical-nav" [ngClass]="{'hk-nav-toggle': isNavbarMinimized}" id="left-side-menu">
    <a id="navbar_toggle_btn" class="navbar-toggle-btn nav-link-hover" (click)="toggleNavbar()">
        <i class="fa fa-bars"></i>
    </a>
<app-layout-template></app-layout-template>

    <!-- Vertical Nav -->
    <nav [ngClass]="!isAdmin ? 'hk-nav hk-nav-dark' : 'hk-nav hk-nav-dark black-bg'" class="overflow-auto navbarScroll">
        <app-left-menu [(isNavbarMinimized)]="isNavbarMinimized"></app-left-menu>
    </nav>
    <!-- /Vertical Nav -->

<!-- /HK Wrapper -->
<main class="hk-pg-wrapper" style="min-height: 100vh;">
    <router-outlet></router-outlet>
</main>
</div>
